<script lang="ts">
    import type Monster from "../../lib/monster";
    import Aura from "./Aura.svelte";
    import Belt from "./Belt.svelte";
    import Body from "./Body.svelte";
    import Legs from "./Legs.svelte";
    import Shield from "./Shield.svelte";
    import Staff from "./Staff.svelte";
    import Sword from "./Sword.svelte";

    export let dimensions: number;
    export let monster: Monster;
</script>

<svg height={dimensions} width={dimensions}>
    <Aura monster={monster} dimensions={dimensions}/>
    <Staff monster={monster} dimensions={dimensions}/>
    <Body monster={monster} dimensions={dimensions}/>
    <Legs monster={monster} dimensions={dimensions}/>
    <Belt monster={monster} dimensions={dimensions}/>
    <Shield monster={monster} dimensions={dimensions}/>
    <Sword monster={monster} dimensions={dimensions}/>
</svg>

<style>

</style>
